import React from "react";
import "./GiftCards.css";
import giftcard1 from "../../images/giftcard1.png";
import giftcard2 from "../../images/giftcard2.png";
import giftcard3 from "../../images/giftcard3.png";
import giftcard4 from "../../images/giftcard4.png";
import giftcard5 from "../../images/giftcard5.png";
import giftcard6 from "../../images/giftcard6.png";
import giftcard7 from "../../images/giftcard7.png";
import giftcard8 from "../../images/giftcard8.png";
import useWindowDimensions from "../../components/getWindowDimensions";

function GiftCards() {
  const { width } = useWindowDimensions();

  return (
    <div className="giftcards-container">
      <div className="giftcards-grid">
        <img src={giftcard1} alt="Gift Card 1" className="giftcard-img" />
        <img src={giftcard2} alt="Gift Card 2" className="giftcard-img" />
        <img src={giftcard3} alt="Gift Card 3" className="giftcard-img" />
        <img src={giftcard4} alt="Gift Card 4" className="giftcard-img" />
        <img src={giftcard5} alt="Gift Card 5" className="giftcard-img" />
        <img src={giftcard6} alt="Gift Card 6" className="giftcard-img" />
        <img src={giftcard7} alt="Gift Card 7" className="giftcard-img" />
        <img src={giftcard8} alt="Gift Card 8" className="giftcard-img" />
      </div>

      <div className="giftcards-form-container">
        <iframe
          title="Gift Card Purchase Form"
          src="https://docs.google.com/forms/d/e/1FAIpQLSeqj5c-Z36AfhVGJIHLUFMUbVpdoJ_4TPtIwwD4lQ89VdmIkQ/viewform?embedded=true"
          width={width < 1060 ? "100%" : "640"}
          height="916"
          style={{ border: "none", marginHeight: 0, marginWidth: 0 }}
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}

export default GiftCards;
